import * as React from 'react';
import { IStore } from 'redux/IStore';
import { IModalAction } from 'models/modal';
import { showModal } from 'modules/modal';
const { connect } = require('react-redux');
import { getMagazineHomePageData } from 'modules/menuitem/menuitem';
import { ErrorPage } from 'containers';
import { Helmet } from 'react-helmet';
import { MagazinePageSectionRenderer } from 'components/Magazine/Page/Sections';
import { IMenuItemData, IMenuItemDataAction } from 'models/menuitem/menuitem';
import { IMagazinePageSection } from 'models/common/section';
const { asyncConnect } = require('redux-connect');

interface IProps {
	pageData: IMenuItemData;
	routeParams?: IParams;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	getMagazineHomePageData: (culture: string) => IMenuItemDataAction;
	baseUrlClient?: string;
}

interface IParams {
	culture?: string;
}

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params }) => {
			const menuItemData = (getState as () => IStore)().menuItem;
			if (menuItemData && menuItemData.menuItem && menuItemData.menuItem.id) {
				return;
			}
			if (params.culture) {
				return Promise.all([dispatch(getMagazineHomePageData(params.culture))]);
			}
		},
	},
])
@connect(
	(state: IStore) => ({
		pageData: state.menuItem,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		getMagazineHomePageData: (culture: string) => dispatch(getMagazineHomePageData(culture)),
	}),
)
class MagazineHome extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}
	public componentDidMount() {
		this.props.getMagazineHomePageData(this.props.routeParams.culture);
	}

	public render() {
		let siteTitle = '';
		let siteDescription = '';
		let siteCode = '';
		let ogImage = '';

		const { page } = (this.props?.pageData && this.props?.pageData) || null;

		if (this.props.pageData.error) {
			return <ErrorPage {...this.props} message={this.props.pageData.message} />;
		}

		if (!this.props.pageData.page || !this.props.pageData.page.sections) {
			return null;
		}

		if (this.props.pageData && this.props.pageData.menuItem) {
			siteTitle = this.props.pageData.menuItem.title;
			siteDescription = this.props.pageData.menuItem.description || '';
			siteCode = this.props.pageData.menuItem.code;
			ogImage = (page?.sections as IMagazinePageSection[]).find((sec) => sec.seoImageUrl)?.seoImageUrl || '';
		}

		const sectionsContent: JSX.Element[] = (page?.sections as IMagazinePageSection[]).map((item, index) => {
			return <MagazinePageSectionRenderer key={index} section={item} />;
		});
		return (
			<div>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: this.props.baseUrlClient + '/magazine/page/' + siteCode }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: ogImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: this.props.baseUrlClient + '/magazine/page/' + siteCode },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
					]}
				/>
				<div className="sections">{sectionsContent}</div>
			</div>
		);
	}
}

export { MagazineHome };
